import React, {ReactElement} from "react";
import {Dialog} from "@headlessui/react";
import {FormattedMessage} from "react-intl";
import {menuManagementActions, menuManagementSelectors} from "./menuManagementSlice";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {ErrorMessage} from "components/UIComponents/ErrorMessage";
import {Spinner} from "components/UIComponents/Spinner";
import {authSelectors} from "features/auth/authSlice";
import {SecondaryButton} from "components/UIComponents/SecondaryButton";
import {PrimaryButton} from "components/UIComponents/PrimaryButton";

export interface DeleteModalProps {

}

export function DeleteModal(props: DeleteModalProps): ReactElement {
    const dispatch = useAppDispatch();
    const menuId = useAppSelector(menuManagementSelectors.deleteModalMenuId);
    const menuName = useAppSelector(menuManagementSelectors.deleteModalMenuName);
    const deleteModalOpen = useAppSelector(menuManagementSelectors.deleteModalOpen);
    const pending = useAppSelector(menuManagementSelectors.deletePending);
    const error = useAppSelector(menuManagementSelectors.deleteError);
    const userId = useAppSelector(authSelectors.customer);

    const closeDeleteModal = () => dispatch(menuManagementActions.closeDeleteModal());
    const deleteMenu = () => {
        if (userId == null) {
            dispatch(menuManagementActions.setDeleteError("keine userId vorhanden"));
            return;
        }

        if (menuId == null) {
            dispatch(menuManagementActions.setDeleteError("keine menuid vorhanden"));
            return;
        }

        return dispatch(menuManagementActions.deleteMenu({
            userId: userId,
            fileId: menuId,
        }));
    };

    return (
        <Dialog
            open={deleteModalOpen}
            onClose={closeDeleteModal}
            className="fixed z-modal inset-0 overflow-y-auto"
        >
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay className="fixed inset-0 bg-text opacity-60"/>

                <div className="relative flex flex-col w-1/3 max-w-sm mx-auto
                                py-6 px-5 bg-white rounded-lg">

                    <div className="flex-none flex items-center">
                        <Dialog.Title className="flex-auto font-barlow text-lg font-semibold">
                            <FormattedMessage id="management.delete.modal.title"/>
                        </Dialog.Title>
                        <button className="flex-none"
                                onClick={closeDeleteModal}>
                            <CloseIcon className="inline-block w-5 h-5" />
                        </button>
                    </div>

                    <div className="flex-auto flex flex-col">
                        <div className="flex-auto pt-5 pb-10">
                            <p><FormattedMessage id="management.delete.modal.text" values={{menuName: menuName}} /></p>

                            {error && (
                                <ErrorMessage><FormattedMessage id="management.delete.modal.error" values={{message: error}} /></ErrorMessage>
                            )}
                        </div>


                        <div className="flex-none flex gap-2 justify-end items-center">
                            {pending && (
                                <Spinner className="flex-none w-8 h-8 inline-block" />
                            )}

                            <SecondaryButton onClick={closeDeleteModal}>
                                <FormattedMessage id="management.delete.modal.button.cancel" />
                            </SecondaryButton>

                            <PrimaryButton disabled={pending} onClick={deleteMenu}>
                                <FormattedMessage id="management.delete.modal.button.submit" />
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}